import React from "react";
import * as Animate from "react-reveal";

const DriveSection = () => {
  return (
    <section className="relative pt-24 lg:pt-32 pb-32 lg:pb-40">
      <div className="relative container mx-auto px-4">
        <div className="w-full lg:w-10/12 mx-auto">
          <Animate.Fade bottom>
            <h3 className="w-full lg:w-8/12 mx-auto font-semibold text-2xl md:text-3xl lg:text-4xl xl:text-4xl xl:leading-snug text-primary text-center font-mono">
              Blockchain Technology
            </h3>
            <p className="w-full lg:w-7/12 mx-auto text-center mt-6 lg:mt-8 text-base lg:text-lg">
              Understand the transformative potential of cryptocurrency and
              blockchain technology where you get to explore the dynamics and
              develop solutions for blockchain platforms. Create your own
              private blockchain, and secure a digital asset using blockchain
              identity. Explore the Ethereum platform and use solidity and smart
              contracts to develop your own decentralized app.
            </p>
          </Animate.Fade>
        </div>
      </div>
    </section>
  );
};

export default DriveSection;
